module.exports = __webpack_public_path__ + "img/top_300.db16b5b1.png";